// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React, { ReactNode } from 'react';
import { IconButton, Paper, PaperProps } from '@mui/material';
import { Box } from '@mui/system';
import SVG from 'react-inlinesvg';
import sideBarIcon from 'Assets/sidebar-icon.svg';
import stylesDef from './styles';

interface ComponentProps extends Omit<PaperProps, 'children'> {
  children?: ReactNode;
  collapsed?: boolean;
  onExpand?: () => void;
}

export const Sidebar: React.FC<ComponentProps> = ({ children, collapsed, onExpand, ...props }) => {
  const styles = stylesDef();

  if (collapsed) {
    return (
      <Paper sx={styles.sidebar} elevation={1} {...props}>
        <Box sx={styles.collapsedContent}>
          <IconButton size="small" onClick={onExpand} aria-label="Expand sidebar">
            <SVG src={sideBarIcon} style={styles.expandIcon} />
          </IconButton>
        </Box>
      </Paper>
    );
  }

  return (
    <Paper sx={styles.sidebar} elevation={1} {...props}>
      {children}
    </Paper>
  );
};

export default Sidebar;
